import { Action, combineReducers } from 'redux';

import { previousUrlReducer } from '../../app/reducers/PreviousUrlReducer';
import { NavigationState } from '../state/NavigationState';
import { navLocationReducer } from './NavLocationReducer';

export const navigationReducer: (
  previousState: NavigationState,
  action: Action
) => NavigationState = combineReducers<NavigationState>(
  {
    navLocation: navLocationReducer,
    previousUrl: previousUrlReducer
  }
);
